"use client"

import { SnackbarProvider } from "@recall/common"
import { PHProvider } from "./PHProvider"
import ThemeRegistry from "@/theme/ThemeRegistry"
import { FC, PropsWithChildren } from "react"

export const Providers: FC<PropsWithChildren> = ({ children }) => {
    return (
        <PHProvider>
            <ThemeRegistry options={{ key: "recall" }}>
                <SnackbarProvider>{children}</SnackbarProvider>
            </ThemeRegistry>
        </PHProvider>
    )
}
